export default __webpack_public_path__ + "static/media/Discount.e0aa4270.svg";